module.exports = __webpack_public_path__ + "img/splash-talktomaria.2eb5fa69.png";